import { IngestCoreBase } from "./ingest.core.base"


export class IngestCore extends IngestCoreBase {

}